/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Footer_TaglineInputs */

const es_privacy_policy_footer_tagline = /** @type {(inputs: Privacy_Policy_Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu conocimiento empresarial, unificado.`)
};

const en_privacy_policy_footer_tagline = /** @type {(inputs: Privacy_Policy_Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your enterprise knowledge, unified.`)
};

/**
* | output |
* | --- |
* | "Your enterprise knowledge, unified." |
*
* @param {Privacy_Policy_Footer_TaglineInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_footer_tagline = /** @type {((inputs?: Privacy_Policy_Footer_TaglineInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Footer_TaglineInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_footer_tagline(inputs)
	return en_privacy_policy_footer_tagline(inputs)
});
export { privacy_policy_footer_tagline as "privacy_policy.footer_tagline" }